import { DeleteNotificationsSubscriptionSubscribedEventInput, NotificationSubscriptionSubscribedEvent } from '@clipr/lib';
import { action, makeObservable, observable } from 'mobx';
import { ApiRequestMode } from '../../api';
import { notifyError } from '../../services/notifications';
import { StoreNode } from '../../store';
import { Store } from '../../store/store';

export class UnsubscribePageState extends StoreNode {
  constructor(store: Store) {
    super(store);
    makeObservable(this, {
      notificationLabel: observable,
      unsubscribedSuccessfully: observable,
      isLoading: observable,
      token: observable,
      email: observable,
      subscribedEvent: observable,
      mounted: action,
      unsubscribe: action,
      reset: action,
    });
  }

  notificationLabel: string | null = null;
  unsubscribedSuccessfully: boolean = false;
  isLoading: boolean = false;
  token: string | null = null;
  email: string | null = null;
  subscribedEvent: NotificationSubscriptionSubscribedEvent | null = null;

  mounted(search: string) {
    const query = new URLSearchParams(search);

    const eventType = query.get('type');
    const destination = query.get('destination');
    const token = query.get('token');

    if (destination) this.email = atob(destination);
    if (token) this.token = token;
    if (eventType) this.subscribedEvent = eventType as NotificationSubscriptionSubscribedEvent;

    switch (eventType) {
      case 'JobDone':
        this.notificationLabel = 'Video Processed';
        break;

      case 'JobWaiting':
        this.notificationLabel = 'Video Processing';
        break;

      case 'JobDownloadFailed':
        this.notificationLabel = 'Video Processing Failed';
        break;

      case 'TeamInvitation':
        this.notificationLabel = 'Team Invite';
        break;

      case 'TeamIsPublic':
        this.notificationLabel = 'Team goes shareable';
        break;
    }
  }

  async unsubscribe() {
    this.isLoading = true;

    let args: DeleteNotificationsSubscriptionSubscribedEventInput;

    if (this.subscribedEvent) {
      args = { token: this.token ?? '', subscribedEvent: this.subscribedEvent }
      const [, err] = await this.store.api.deleteNotificationsSubscriptionSubscribedEvent({ args }, { 
        mode: ApiRequestMode.Direct
      });

      this.isLoading = false;

      if (err) {
        notifyError(this, `Something went wrong.`);
        return;
      }

      this.unsubscribedSuccessfully = true;
    }
  }

  reset() {
    this.token = null;
    this.email = null;
    this.isLoading = false;
    this.subscribedEvent = null;
    this.notificationLabel = null;
    this.unsubscribedSuccessfully = false;
  }
}
